<template>
  <div class="ui-pivot-table__sidebar__block__field" :class="mainClasses">
    <div
      class="ui-pivot-table__sidebar__block__field__state"
      :class="stateClasses"
      @click="handleToggle"
    />
    <div class="ui-pivot-table__sidebar__block__field__caption">
      {{ caption }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { PivotTableField } from '../utils/types'
import { prepareCaption } from '../utils/helpers'

type Props = {
  field: string
  item: PivotTableField
}

type Emits = {
  toggle: [field: string, data: boolean]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const captions = inject<Record<string, string>>('captions', {})

const caption = computed(() =>
  prepareCaption(props.field, captions?.[props.field]),
)

const mainClasses = computed(() => ({
  'ui-pivot-table__sidebar__block__field--enabled': props.item.enabled,
}))

const stateClasses = computed(() => ({
  'ui-pivot-table__sidebar__block__field__state--enabled': props.item.enabled,
}))

const handleToggle = () => {
  emit('toggle', props.field, !props.item.enabled)
}
</script>

<style>
.ui-pivot-table__sidebar__block__field {
  @apply flex justify-between;
  @apply p-1;
  @apply rounded-full;
  @apply bg-gray-500 hover:bg-gray-800;
  @apply dark:bg-gray-750 dark:hover:bg-gray-900;
  @apply text-gray-50 dark:text-gray-300;
  @apply text-sm sm:text-xs;
  @apply cursor-move;

  &--enabled {
    @apply bg-gray-700 dark:bg-gray-900;
  }

  &__caption {
    @apply mx-1;
    @apply flex-auto;
  }

  &__state {
    @apply w-4 h-4;
    @apply flex items-center justify-center;
    @apply bg-white dark:bg-gray-500;
    @apply text-gray-500 dark:text-gray-300;
    @apply rounded-full;
    @apply cursor-pointer;

    &--enabled {
      @apply after:block after:w-3 after:h-3;
      @apply after:bg-gray-700 dark:after:bg-gray-950;
      @apply after:rounded-full;
    }
  }
}
</style>
